import OtherProductId from "~/constants/OtherProductId";

const SubscriptionOtherProducts = [
  OtherProductId.UI_MEET_3D_ACTIVE_1,
  OtherProductId.UI_MEET_3D_ACTIVE_5,
  OtherProductId.UI_MEET_3D_ACTIVE_12,
  OtherProductId.UI_MEET_3D_ACTIVE_50,
  OtherProductId.UI_MEET_3D_UNLIMITED,
];

export default SubscriptionOtherProducts;
